import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  resolveBillingCTA,
  type BillingAccessShape,
  type BillingCTA,
  type BillingStateShape,
} from '@/utils/resolveBillingCTA';

export type TranslatedBillingCTA = BillingCTA & {
  primaryLabel: string | null;
  secondaryLabel: string | null;
};

export function useBillingCTA(
  billingState?: BillingStateShape | null,
  hasActiveBilling?: boolean,
  opts?: { billingConfigured?: boolean; billingAccess?: BillingAccessShape | null },
): TranslatedBillingCTA {
  const { t } = useTranslation();
  const cta = useMemo(
    () => resolveBillingCTA(billingState, hasActiveBilling, opts),
    [billingState, hasActiveBilling, opts?.billingConfigured, opts?.billingAccess],
  );

  return useMemo(
    () => ({
      ...cta,
      primaryLabel: cta.primaryLabelKey
        ? t(cta.primaryLabelKey, cta.primaryLabelParams)
        : null,
      secondaryLabel: cta.secondaryLabelKey ? t(cta.secondaryLabelKey) : null,
    }),
    [cta, t],
  );
}
